import {createAction, props} from '@ngrx/store';
import {StronaStartowaActionType} from './strona-startowa-action-type';
import {Samoobsluga} from '../../../shared/services/samoobsluga/types/samoobsluga';

export const kliknietoRozpocznij = createAction(StronaStartowaActionType.KLIKNIETO_ROZPOCZNIJ, props<{correlationId: string}>());
export const kliknietoRozpocznijSuccess = createAction(StronaStartowaActionType.KLIKNIETO_ROZPOCZNIJ_SUCCESS, props<Samoobsluga>());
